module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-3.3b76dbcc.jpg";